import IWithdrawalLayer from "./IWithdrawalLayer";
import UIManager from "../../Shared/UIManager";
import NetworkLogic from "../../Shared/NetworkLogic";
import CommonToggleContainer from "../../Common/CommonToggleContainer";
import ToggleItem from "../../Common/ToggleItem";
import SelectBankLayer from "./SelectBankLayer";
import Player from "../../Models/Player";
import { Global } from "../../Shared/Global";

const {ccclass, property} = cc._decorator;

@ccclass
export default class SelfHelpWithdrawalLayer extends IWithdrawalLayer {
    @property(CommonToggleContainer)
    toggleContainerParent: CommonToggleContainer = null

    @property(CommonToggleContainer)
    toggleContainer: CommonToggleContainer = null

    @property(SelectBankLayer)
    selectBankLayer: SelectBankLayer = null

    @property(cc.Node)
    nodeInfo: cc.Node = null

    @property(cc.Node)
    nodeTixianMima: cc.Node = null

    @property(cc.Node)
    nodeInputPossword: cc.Node = null

    @property(cc.Node)
    nodeBankCard: cc.Node = null

    @property(cc.Node)
    nodeNoBankCard: cc.Node = null
    
    @property(cc.EditBox)
    ebMoney: cc.EditBox = null

    @property(cc.EditBox)
    ebPassword: cc.EditBox = null

    @property(cc.EditBox)
    ebPasswordConfirm: cc.EditBox = null

    @property(cc.EditBox)
    ebInputPassword: cc.EditBox = null

    @property(cc.RichText)
    rtTips: cc.RichText = null

    @property(cc.Slider)
    sliderMoney: cc.Slider = null

    @property(cc.Label)
    lbPercent: cc.Label = null

    @property(cc.Label)
    lbtips: cc.Label = null

    @property(cc.Label)
    lbChangeBank: cc.Label = null

    @property(cc.RichText)
    rtMoney: cc.RichText = null

    @property(cc.RichText)
    rtUsdtRate: cc.RichText = null

    @property(cc.RichText)
    rtUsdtMoney: cc.RichText = null

    private _bankIndex = 0
    private _hasPassword = false
    private _moneyOutLimit = []

    private  bWitdrawInt = false;//是否只能提取整数金额；

    onLoad () {
        this.nodeInfo.active = true
        this.nodeTixianMima.active = false
        this.nodeInputPossword.active = false
        this.selectBankLayer.node.active = true
        this.selectBankLayer.node.active = false
        this.nodeBankCard.active = false
        this.nodeNoBankCard.active = false
    }

    start () {
    }

    onEnable () {
        this.nodeInfo.active = true
        this.nodeTixianMima.active = false
        this.nodeInputPossword.active = false
        this.ebMoney.string = ""
        this.ebInputPassword.string = ""
        this.setSliderProgress(0)
        this.pullGetMoneyOutlimit()
    }

    onDisable () {
        this.toggleContainer.node.destroyAllChildren()        
    }

    onBtnClick (event, userData) {
        if (userData === "clear") {
            this.setSliderProgress(0)
            this.onSlider()
        }else if (userData === "max") {
            this.setSliderProgress(1)
            this.onSlider()
        }else if (userData === "addBank") {
            this.toggleContainerParent.selectToggle(this.toggleContainerParent.node.children[2].getComponent(ToggleItem))
        }else if (userData === "tixian") {
            if (!this.ebMoney.string) {
                UIManager.showToastUI("提现金额不能为空，请填写", Global.ToastType.Warnning)
                return
            }
            
            if (parseFloat(this.ebMoney.string) <= 0) {
                UIManager.showToastUI("提现金额应大于0", Global.ToastType.Warnning)
                return
            }

            let bankList = this.toggleContainer.checkedToggle.userData["bankList"]
            if (bankList) {
                this.nodeInfo.active = false
                if (Player.getPy("isSetDrawPassword")) {
                    this.nodeInputPossword.active = true
                }else {
                    this.nodeTixianMima.active = true
                }
                this.rtMoney.string = `提现金额：<color=#6FF2ED>￥${this.ebMoney.string}元</c>`
                if (bankList[this._bankIndex]["type"] === 3) {
                    this.rtUsdtRate.node.active = true
                    this.rtUsdtMoney.node.active = true
                    this.rtUsdtRate.string = `汇率：<color=#6FF2ED>${bankList[this._bankIndex]["virtualMoneyRate"]}</c>`
                    this.rtUsdtMoney.string = `到账USDT金额：<color=#6FF2ED>${(parseFloat(this.ebMoney.string) / bankList[this._bankIndex]["virtualMoneyRate"]).toFixed(2)}</c>`
                }else {
                    this.rtUsdtRate.node.active = false
                    this.rtUsdtMoney.node.active = false
                }
            }else {
                UIManager.showToastUI("请先绑定" + this.toggleContainer.checkedToggle.userData["label"], Global.ToastType.Warnning)
            }
        }else if (userData === "changeBank") {
            this.selectBankLayer.bankList = this.toggleContainer.checkedToggle.userData["bankList"]
            this.selectBankLayer.selectedIndex = this._bankIndex
            this.selectBankLayer.node.active = true
            this.selectBankLayer.callback = function (index) {
                this._bankIndex = index
                this.refreshBankData()
            }.bind(this)
        }else if (userData === "tijiao") {
            if (!this.ebPassword.string) {
                UIManager.showToastUI("提现密码不能为空，请填写", Global.ToastType.Warnning)
                return
            }else if (!this.ebPasswordConfirm.string) {
                UIManager.showToastUI("确认提现密码不能为空，请填写", Global.ToastType.Warnning)
                return
            }else if (this.ebPassword.string !== this.ebPasswordConfirm.string) {
                UIManager.showToastUI("提现密码与确认密码不一致，请确认", Global.ToastType.Warnning)
                return
            }else if (this.ebPassword.string.length !== 6) {
                UIManager.showToastUI("提现密码应为6位数，请重新填写", Global.ToastType.Warnning)
                return
            }

            NetworkLogic.setDrawingPassword("", this.ebPasswordConfirm.string, function (data) {
                this.nodeTixianMima.active = false
                this.nodeInputPossword.active = true
                Player.setPy("isSetDrawPassword", true)
            }.bind(this))
        }else if (userData === "clearPossword0") {
            this.ebInputPassword.string = ""
        }else if (userData === "clearPossword1") {
            this.ebPassword.string = ""
        }else if (userData === "clearPossword2") {
            this.ebPasswordConfirm.string = ""
        }else if (userData === "tixianConfirm") {
            // 需要补全资料
            if (Player.getPy("visitorFillInfoTime").indexOf("4") !== -1 && Player.getPy("userType") === 2) {
                // 打开界面
                let hallUI = cc.find("Canvas/gameNode").getComponent("HallUI");
                hallUI.openChildUI(hallUI.pfbLoginCompleteInformation);
                return
            }
            this.sendTixianRequest(0)
        }else if (userData === "pre1") {
            this.nodeInfo.active = true
            this.nodeTixianMima.active = false
        }else if (userData === "pre2") {
            this.nodeInfo.active = true
            this.nodeInputPossword.active = false
        }
    }

    onTextChanged () {
        this.ebMoney.string = Math.max(0, Math.min(Player.getPy("money"), (parseFloat(this.ebMoney.string) || 0))).toString();
        if (this.bWitdrawInt){
            this.ebMoney.string = parseInt(this.ebMoney.string).toString();
            if  (parseInt(this.ebMoney.string) > Player.getPy("money")){
                this.ebMoney.string = Math.floor(Player.getPy("money")).toString();
            }
            this.setSliderProgress(Player.getPy("money") === 0 ? 0 : parseInt(this.ebMoney.string) / Player.getPy("money"))
        }else{
            this.setSliderProgress(Player.getPy("money") === 0 ? 0 : parseFloat(this.ebMoney.string) / Player.getPy("money"))
        }
    }

    onSlider () {
        let progress = this.sliderMoney.progress
        this.lbPercent.string = Math.round(progress * 100).toString() + "%"

        if (this.bWitdrawInt){
            this.ebMoney.string =  Math.floor(Player.getPy("money") * progress).toString()
            this.ebMoney.string === "0" && (this.ebMoney.string = "")
        }else{
            this.ebMoney.string = (Player.getPy("money") * progress).toFixed(2).toString()
            this.ebMoney.string === "0.00" && (this.ebMoney.string = "")

        }
    }

    onToggleSelected (toggle: ToggleItem) {
        this.setSliderProgress(0)
        this.onSlider()
        this.bWitdrawInt = toggle.userData["isInt"] ;
        this._bankIndex = 0
        this.lbtips.string = "您暂时未绑定" + toggle.userData["label"] + "，请前往绑定"
        this.lbChangeBank.string = "更换" + toggle.userData["label"]
        let bankList = toggle.userData["bankList"] || []

        if (bankList.length === 0) {
            this.nodeBankCard.active = false
            this.nodeNoBankCard.active = true
        }else {
            this.nodeBankCard.active = true
            this.nodeNoBankCard.active = false
            this.refreshBankData()
        }

        this.refreshMoneyLimit(parseInt(toggle.userData["value"]))
    }

    private pullGetMoneyOutlimit () {
        UIManager.showLoadingUI()
        NetworkLogic.getMoneyOutlimit(function (data) {
            this._moneyOutLimit = data
            NetworkLogic.getAllPaymentByUser(function (data) {
                UIManager.hideLoadingUI()
                cc.log("=====获取提现列表：",data);
                this.createToggles(data.accountList)
            }.bind(this))
        }.bind(this), function (response) {
            UIManager.showChangeDomainUI(function () {
                this.pullGetMoneyOutlimit()
            }.bind(this))
        }.bind(this))
    }

    private refreshMoneyLimit (paymentType) {
        this._moneyOutLimit[paymentType] && (this.rtTips.string = "提现金额 " + this._moneyOutLimit[paymentType].limitOfPayment + " 之间")
    }

    private setSliderProgress(progress) {

        this.sliderMoney.progress = progress
        // if  (this.bWitdrawInt){
        //
        // }
        this.lbPercent.string = Math.round(progress * 100).toString() + "%"
    }

    private createToggles (accountList) {
        accountList.forEach(cfg => {
            this.toggleContainer.addDefaultToggle(cfg.label, cfg)
        });
    }

    private refreshBankData () {
        let bankList = this.toggleContainer.checkedToggle.userData["bankList"]
        let cfg = bankList[this._bankIndex]
        this.nodeBankCard.getChildByName("name").getComponent(cc.Label).string = cfg.bankname
        this.nodeBankCard.getChildByName("account").getComponent(cc.Label).string = cfg.bankNum
        cfg.logoUrl && cc.loader.load({url: cfg.logoUrl, type: "png"}, function (err, texture) {
            if (this.node) {
                if (!err) {
                    this.nodeBankCard.getChildByName("icon").getComponent(cc.Sprite).spriteFrame = new cc.SpriteFrame(texture)
                }else {
                    this.nodeBankCard.getChildByName("icon").getComponent(cc.Sprite).spriteFrame = null
                }
            }
        }.bind(this))
    }

    private sendTixianRequest (flag) {
        if (!this.ebInputPassword.string) {
            UIManager.showToastUI("提现密码不能为空，请填写", Global.ToastType.Warnning)
            return
        }else if (this.ebInputPassword.string.length < 6) {
            UIManager.showToastUI("提现密码应为6位数，请重新填写", Global.ToastType.Warnning)
            return
        }

        let bankList = this.toggleContainer.checkedToggle.userData["bankList"]
        let cfg = bankList[this._bankIndex]
        UIManager.showLoadingUI()
        NetworkLogic.applyPaymentout({
            "bankNo": cfg.bankNo,
            "money": this.ebMoney.string || 0,
            "type": cfg.type,
            "outMoneyFlag": flag,
            "payPwd": this.ebInputPassword.string,
        }, function (data) {
            UIManager.hideLoadingUI()
            UIManager.showToastUI("提现请求已提交", Global.ToastType.OK)
            this.nodeInfo.active = true
            this.nodeInputPossword.active = false
        }.bind(this), function (response) {
            if (!response) return
            if (response.code === "201") {
                // 解决两种弹窗重叠的问题
                UIManager.hideToastUI()
                UIManager.showConfirmUI(response.msg.replace(/&/g, "\n"), function () {
                    this.sendTixianRequest(1)
                }.bind(this), "继续提现", null, "放弃提现")
            }
        }.bind(this))
    }
}
